var addTouch=function(obj,options){
    options=$.extend({
        onStart:function(arr){},
        onEnd:function(arr){},
        onMove:function(arr){},
        onMouseDown:function(arr){},
        onMouseUp:function(arr){}

    },options);
    var canvas=obj;
    canvas.width=canvas.offsetWidth;
    var offset=$(canvas).offset();
    function countOffset(){
        offset=$(canvas).offset();
//            offset.left=Math.round(offset.left*_scaleObj.scale);
//            offset.top=Math.round(offset.top*_scaleObj.scale);
    }
    countOffset();
    _moduleEvents.on("change_offset",function(){
        countOffset();
    });

    var self={
        init:function(){
            canvas.addEventListener('touchstart',self.start,false);
            canvas.addEventListener('touchmove',self.move,false);
            canvas.addEventListener('touchend',self.end,false);
            canvas.addEventListener('mousedown',self.mouseDown,false);
            canvas.addEventListener('mouseup',self.mouseUp,false);
            return this;
        }
        ,start:function(event){
            var posObj=[];
            $.each(event.touches,function(i,touch){
//                    $.qLog(Math.round((this.pageX-offset.left)/_scaleObj.scale)+"_"+Math.round((this.pageY-offset.top)/_scaleObj.scale)+" ");
                posObj.push([Math.round((this.pageX-offset.left)/_scaleObj.scale),Math.round((this.pageY-offset.top)/_scaleObj.scale)]);
            });
            if(event.cancelable){
                event.preventDefault();
            }
            options.onStart(posObj);
        }
        ,end:function(event){
            var posObj=[];
            $.each(event.touches,function(i,touch){
                posObj.push([Math.round((this.pageX-offset.left)/_scaleObj.scale),Math.round((this.pageY-offset.top)/_scaleObj.scale)]);
            });
            if(event.cancelable){
                event.preventDefault();
            }
            
            options.onEnd(posObj);
        }
        ,move:function(event){
            var posObj=[];
            $.each(event.touches,function(i,touch){
                posObj.push([Math.round((this.pageX-offset.left)/_scaleObj.scale),Math.round((this.pageY-offset.top)/_scaleObj.scale)]);
            });
            if(event.cancelable){
                event.preventDefault();
            }
            
            options.onMove(posObj);
        },
        mouseDown:function(event){
            options.onMouseDown([[$.getXeventOffset(event),$.getYeventOffset(event)]]);
            
        },
        mouseUp:function(event){
            options.onMouseUp([[$.getXeventOffset(event),$.getYeventOffset(event)]]);
            
        },
        test:function(){
            $.qLog("mis");
        }
    };
    return self.init();
};
